import "./datasetPopup.css"

function setUpDatasetPopup(scope) {
  scope.querySelectorAll(".dataset-popup").forEach(popup => {
    popup.addEventListener("close", event => {
      document.body.classList.remove("popup-open");
      fetch('index.php?controller=index&function=closeDatasetPopup&ajax=1').catch(reason => {
        console.warn("[dataset-popup] server popup close notification failed", reason);
      });
    });
  });
}

export {setUpDatasetPopup};
